export default "__VITE_ASSET__C1EqL0gH__"